import { API_PREFIX } from '@camper-diary/shared';

export type ApiError = {
  code: string;
  message: string;
  details?: Record<string, unknown>;
};

export class HttpError extends Error {
  constructor(
    public status: number,
    public apiError: ApiError,
  ) {
    super(apiError.message);
  }
}

type Options = {
  method?: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';
  body?: unknown;
  headers?: Record<string, string>;
};

export async function api<T>(path: string, opts: Options = {}): Promise<T> {
  const url = path.startsWith('/api/') ? path : `${API_PREFIX}${path}`;
  const headers: Record<string, string> = {
    Accept: 'application/json',
    'X-Requested-With': 'fetch',
    ...opts.headers,
  };
  if (opts.body !== undefined && !(opts.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  const res = await fetch(url, {
    method: opts.method ?? 'GET',
    credentials: 'same-origin',
    headers,
    body:
      opts.body === undefined
        ? undefined
        : opts.body instanceof FormData
          ? opts.body
          : JSON.stringify(opts.body),
  });

  const json = await res.json().catch(() => ({
    data: null,
    error: { code: 'INVALID_RESPONSE', message: 'Risposta non JSON' },
    meta: {},
  }));

  if (!res.ok) {
    throw new HttpError(res.status, json.error ?? {
      code: 'HTTP_ERROR',
      message: `HTTP ${res.status}`,
    });
  }
  return json.data as T;
}
